<template>
    <setting-layout :title="$t('pages.profile.info.title')">
        <v-container class="mt-0 pt-1 pl-10 pr-10">
            <v-row justify="center" class="ml-5">
                <div
                    class="image-container"
                    :class="{ 'story-exist': $auth.user().isExistStory }"
                    @click="handleChangeAvatar"
                >
                    <profile-image
                        :src="model.profileImage"
                        :username="user.name"
                        :size="95"
                        :font-size="31"
                    />
                </div>
                <div class="follow-button">
                    <app-icon
                        icon="write"
                        color="red"
                        size="16"
                        @click="handleChangeAvatar"
                    />
                </div>
            </v-row>
            <v-row class="mt-6">
                <v-textarea
                    class="bio"
                    color="rgba(237,237,237, .1)"
                    background-color="rgba(237,237,237, .1)"
                    hide-details
                    no-resize
                    solo
                    :placeholder="$t('pages.profile.info.type_your_bio')"
                    rows="4"
                    v-model="model.bio"
                >
                </v-textarea>
            </v-row>
            <v-row class="mt-6">
                <text-field
                    ref="amazonField"
                    v-model="model.amazon"
                    :error="!!errors.amazon"
                    :error-messages="errors.amazon"
                    :placeholder="$t('pages.profile.info.amazon_url')"
                >
                    <template v-slot:prepend-inner>
                        <app-icon
                            icon="amazon"
                            size="20"
                            class="mr-2"
                        ></app-icon>
                    </template>
                    <template v-slot:append>
                        <v-icon @mouseup.stop @click.prevent.stop="copyUrl(model.amazon)">mdi-content-copy</v-icon>
                    </template>
                </text-field>
            </v-row>
            <v-row class="mt-6">
                <text-field
                    ref="instagramField"
                    v-model="model.instagram"
                    :error="!!errors.instagram"
                    :error-messages="errors.instagram"
                    :placeholder="$t('pages.profile.info.instagram_url')"
                >
                    <template v-slot:prepend-inner>
                        <v-icon size="20" class="mr-2">mdi-instagram</v-icon>
                    </template>
                    <template v-slot:append>
                        <v-icon @mouseup.stop @click.prevent.stop="copyUrl(model.instagram)">mdi-content-copy</v-icon>
                    </template>
                </text-field>
            </v-row>
            <v-row class="mt-6">
                <text-field
                    ref="twitterField"
                    v-model="model.twitter"
                    :error="!!errors.twitter"
                    :error-messages="errors.twitter"
                    :placeholder="$t('pages.profile.info.twitter_url')"
                >
                    <template v-slot:prepend-inner>
                        <img
                            :src="require('@/assets/images/logo/x.png')"
                            alt="x"
                            title="x"
                            width="20px"
                            class="mr-2"
                        />
                    </template>
                    <template v-slot:append>
                        <v-icon @mouseup.stop @click.prevent.stop="copyUrl(model.twitter)">mdi-content-copy</v-icon>
                    </template>
                </text-field>
            </v-row>
            <v-row class="align-center mt-3">
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center"> 
                        <label for="show-achievements-toggle" class="mb-0">
                            {{ $t('pages.profile.info.show_achievements') }}
                        </label>
                       <v-switch
                            id="show-achievements-toggle"
                            v-model="model.showAchievementsSection"
                            hide-details
                            class="ma-0 pa-0"
                        />
                    </div>
                    <span class="toggle-description">{{ $t('pages.profile.info.show_achievements_desc') }}</span>
                </v-col>
            </v-row>
            <v-row class="align-center mt-1">
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center"> 
                        <label for="show-toptipper-toggle" class="mb-0">
                            {{ $t('pages.profile.info.show_top_tippers') }}
                        </label>
                       <v-switch
                            id="show-toptipper-toggle"
                            v-model="model.showTopTipperSection"
                            hide-details
                            class="ma-0 pa-0"
                        />
                    </div>
                    <span class="toggle-description">{{ $t('pages.profile.info.show_top_tippers_desc') }}</span>
                </v-col>
            </v-row>  
            <v-row class="align-center mt-1">
                <v-col cols="12">
                    <div class="d-flex justify-space-between align-center"> 
                        <label for="show-toptipper-toggle" class="mb-0">
                            {{ $t('pages.profile.info.online_status') }}
                        </label>
                        <v-switch
                        id="show-online-status-toggle"
                        v-model="model.showOnlineStatus"
                        hide-details
                        class="ma-0 pa-0"
                        />
                    </div>
                    <span class="toggle-description">{{ $t('pages.profile.info.online_status_desc') }}</span>
                </v-col>
            </v-row>
            <v-row class="mt-8 pr-2 pl-2">
                {{ $t("pages.profile.info.my_age") }}
            </v-row>
            <v-row align="baseline" class="pr-2 pl-2 mt-1">
                18
                <v-slider
                    v-model="model.age"
                    thumb-label
                    min="18"
                    max="100"
                    :class="{ 'cursor-slider': true }"
                ></v-slider>
                100
            </v-row>
            <v-row class="pr-2 pl-2">
                {{ $t("pages.profile.info.i_am") }}
            </v-row>
            <v-row justify="center">
                <v-col v-for="(item, i) in genders" :key="i">
                    <div
                        :class="{
                            'select-gender': true,
                            'pa-2': true,
                            active: item.icon === model.gender,
                        }"
                        @click="model.gender = item.icon"
                    >
                        <app-icon
                            :icon="item.icon"
                            class="gender-icon"
                            size="16"
                        />
                        <p>{{ item.text }}</p>
                    </div>
                </v-col>
            </v-row>

            <v-row class="mt-3 pr-2 pl-2">
                {{ $t("pages.profile.info.my_countries") }}
            </v-row>
            <v-row align="baseline" class="pr-2 pl-2 mt-1">
                    <v-autocomplete v-model="model.country_id" :items="countries.filter(c => c.name !== 'All')" item-text="name" item-value="id" label="Select Country" >
                        <template v-slot:item="{ item }">
                            <img :src="require(`@/assets/images/flags/${item.code.toLowerCase()}.png`)" :alt="item.name" class="flags mr-4" />
                            {{ item.name }}
                        </template>

                        <template v-slot:selection="{ item }">
                            <img :src="require(`@/assets/images/flags/${item.code.toLowerCase()}.png`)" :alt="item.name" class="flags mr-2" />
                            {{ item.name }}
                        </template>
                    </v-autocomplete>
            </v-row>

            <v-row class="pr-2 pl-2 mt-4">
                {{ $t("pages.profile.info.categories") }}
            </v-row>
            <v-row>
                <user-categories :user-gender="model.gender" :initial-selected-ids="preSelectedCategoryIds" @update:selectedCategoryIds="handleSelectedCategories" />
            </v-row>

            <v-row align="center" justify="center" class="mt-10 ml-5 mr-5">
                <gradient-button
                    block
                    @click="save"
                    :loading="$store.state.buttonsLoading.infoBtn"
                >
                    {{ $t("dialogs.save") }}
                </gradient-button>
            </v-row>
        </v-container>
        <app-transition>
            <record-screen
                v-if="step === 0"
                :disable-video="true"
                :disable-audio="true"
                key="screen"
                :is-front-camera="isFrontCamera"
                @change-camera="isFrontCamera = $event"
            />
            <view-avatar
                v-if="step === 1"
                key="result"
                @set-image="handleSetImage"
            />
        </app-transition>
    </setting-layout>
</template>

<script>
import * as clipboardy from 'clipboardy'
import SettingLayout from "@/layouts/app/profile/SettingLayout";
import { mapActions, mapMutations, mapState } from "vuex";
import TextField from "@/components/app/form/TextField";
import GradientButton from "@/components/app/button/GradientButton";
import ProfileImage from "@/components/app/notifications/ProfileImage";
import RecordScreen from "@/views/app/postingView/RecordScreen";
import ViewAvatar from "@/views/app/postingView/ViewAvatarScreen";
import UserCategories from "@/components/app/profile/UserCategories";
import EventBus from '../../../../event-bus';

export default {
    name: "Info",
    data() {
        return {
            model: {
                bio: "",
                amazon: "",
                age: 18,
                gender: "",
                profileImage: "",
                categories: [],
                showAchievementsSection: false,
                showTopTipperSection: true,
                showOnlineStatus: false,
                country_id: "",
            },
            errors: {},
            lastCopyAt: 0,
            selectedCountry: null,
            file: new Blob(),
            isFrontCamera: false,
            preSelectedCategoryIds: {},
        };
    },
    methods: {
        ...mapActions([
            "setProfileInfo",
            "getCurrentUserData",
            "getOwnMainUserData",
            "getCountries",
        ]),
        ...mapMutations(["setStep", "showSnackBar"]),
        setModel(value) {
            this.model = {
                bio: value.bio || "",
                amazon: value.amazon || "",
                twitter: value.twitter || "",
                instagram: value.instagram || "",
                age: value.age || 18,
                gender: value.gender || "",
                profileImage: value.profileImage || "",
                changeAvatar: false,
                showAchievementsSection: value.show_achievements_section,
                showTopTipperSection: value.show_top_tippers_section,
                showOnlineStatus: value.status,
                country_id: value.country_id || "",
            };

            if (value.categories) {                
                this.preSelectedCategoryIds = value.categories.reduce((acc, category) => {
                    acc[category.parent_id] = category.id;
                    return acc;
                }, {});
            }
        },
        save() {
            
            this.errors = {}; // reset errors

            if (this.model.amazon && !this.validateDomain(this.model.amazon, 'amazon')) {
                this.errors.amazon = 'Invalid Amazon link';
            }

            if (this.model.instagram && !this.validateDomain(this.model.instagram, 'instagram')) {
                this.errors.instagram = 'Invalid Instagram link';
            }

            if (this.model.twitter && !this.validateDomain(this.model.twitter, 'twitter')) {
                this.errors.twitter = 'Invalid Twitter link';
            }

            if (Object.keys(this.errors).length) {
                this.$nextTick(() => {
                    if (this.errors.amazon && this.$refs.amazonField) {
                        this.$refs.amazonField.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    } else if (this.errors.instagram && this.$refs.instagramField) {
                        this.$refs.instagramField.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    } else if (this.errors.twitter && this.$refs.twitterField) {
                        this.$refs.twitterField.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            
                return;
            }

            this.setProfileInfo({ model: this.model }).then(() => {
                this.showSnackBar(this.$t('pages.user.setting.info.profile_updated'));
                this.getCurrentUserData().then((res) => {
                    this.setModel(res.data);
                    this.getOwnMainUserData(res.data);

                    EventBus.$emit('online-status-changed');
                });
            });
        },
        handleChangeAvatar() {
            this.setStep(0);
        },
        handleSetImage() {
            this.model.changeAvatar = true;
            this.model.profileImage = this.imageDataUrl;
        },
        handleSelectedCategories(selectedIds) {
            this.model.categories = Object.values(selectedIds);
        },
        async fetchCountries () {
            try {
                const response = await this.getCountries();
                this.countries = response || {};
            } catch (error) {
                console.error("Error fetching hall of fame data:", error);
            }
        },
        copyUrl(value) {
            const now = Date.now();
            // simple throttle to avoid rapid/rage clicks triggering repeatedly
            if (now - this.lastCopyAt < 1000) {
                return;
            }

            this.lastCopyAt = now;

            if (!value) {
                this.showSnackBar(this.$t('dialogs.nothing_to_copy'));
                return;
            }

            clipboardy.write(value);
            this.showSnackBar(this.$t('dialogs.copied_clipboard'));
        },
        validateAmazon(value) {
            this.errors.amazon = this.validateDomain(value, 'amazon')? '' : 'Invalid Amazon link';
        },
        validateInstagram(value) {
            this.errors.instagram = this.validateDomain(value, 'instagram')? '' : 'Invalid Instagram link';
        },
        validateTwitter(value) {
            this.errors.twitter = this.validateDomain(value, 'twitter')? '' : 'Invalid X link';
        },
        validateDomain(url, platform) {
            try {
                const parsed = new URL(url);
                const host = parsed.hostname.replace(/^www\./, '');

                const rules = {
                    instagram:
                        host === 'instagram.com' || host.endsWith('.instagram.com'),
                    amazon:
                        host.startsWith('amazon.') ||
                        host.startsWith('amzn.') ||
                        host.startsWith('a.'),
                    twitter:
                        host === 'x.com' ||
                        host.endsWith('.x.com') ||
                        host === 'twitter.com' ||
                        host.endsWith('.twitter.com'),
                };

                return rules[platform] === true;
            } catch {
                return false;
            }
        }
    },
    watch: {
        user(value) {
            this.setModel(value);
        },
        step(value) {
            if ([0, 1].includes(value)) {
                document.getElementsByTagName("html")[0].style.overflow =
                    "hidden";
            } else {
                document.getElementsByTagName("html")[0].style.overflow =
                    "scroll";
            }
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.user.user.data,
            step: (state) => state.story.isShowCameraScreen.step,
            imageDataUrl: (state) => state.story.imageDataUrl,
            countries: (state) => state.story.countries
        }),
        genders() {
            return [
                { text: this.$t("pages.profile.info.male"), icon: "male" },
                { text: this.$t("pages.profile.info.female"), icon: "female" },
                {
                    text: this.$t("pages.profile.info.transgender"),
                    icon: "transgender",
                },
            ];
        },
    },
    components: {
        GradientButton,
        TextField,
        SettingLayout,
        RecordScreen,
        ViewAvatar,
        ProfileImage,
        UserCategories,
    },
    mounted() {
        this.setModel(this.user);
        this.$mixpanel.identifyUser(this.user.email);
        this.$mixpanel.pageViewed('Info');
        if (!this.countries || Object.keys(this.countries).length === 0) {
            this.fetchCountries();
        }
    },
};
</script>

<style scoped lang="scss">
@import "@/sass/modules/_variables";

.profile-image {
    height: 95px;
    width: 95px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-color: whitesmoke;
    background-size: cover;
    object-fit: cover;
}

.image-container {
    border-radius: 50%;
    padding: 4px;
}

.story-exist {
    background: $accent-background;

    .profile-image {
        border: 3px solid black;
        object-fit: cover;
    }
}

.name {
    font-size: 1.5em;
}

.counters {
    font-size: 1.5em;
}

.linked {
    text-decoration: none;
}

$size-button: 34px;
.follow-button {
    height: $size-button;
    width: $size-button;
    background: white;
    text-align: center;
    text-decoration: none;
    color: #fe4811;
    border-radius: 50%;
    border: 3px solid black;
    padding-top: 0;
    position: relative;
    left: -30px;
    bottom: -62px;
    font-size: 1.3em;
    font-weight: bold;
    cursor: pointer;
}

.bio {
    color: rgba(255, 255, 255, 0.7);
    text-align: justify;
    line-height: 1.2em;
}

::v-deep .v-textarea.bio  textarea {
    line-height: 1.3;
}

.top-icon {
    text-align: center;
}

.select-gender.active {
    box-shadow: 0px 2px 17px 0px #fe6c11;
    background: $accent-background;
    border: 1px solid #fe4811;

    & .gender-icon {
        color: white !important;
    }
}

.select-gender {
    border: 1px solid #ededed;
    height: 60px;
    border-radius: 8px;
    text-align: center;
    transition: 0.4s;
    cursor: pointer;

    & .gender-icon {
        color: #9e9ca5 !important;
    }
}

.cursor-slider .v-slider--horizontal {
    cursor: pointer;
}

.flags {
  width: 20px;
  height: 14px;
  object-fit: cover;
  border-radius: 2px;
}

.toggle-description {
    font-size: 13px;
}

</style>
